import { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class InactivityWarning extends PureComponent {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    startTimer: PropTypes.func.isRequired,
    clearTimer: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.startTimer();
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (!this.props.isLoggedIn && nextProps.isLoggedIn) {
      this.props.startTimer();
    } else if (this.props.isLoggedIn && !nextProps.isLoggedIn) {
      this.props.clearTimer();
    }
  }

  render = () => null;
}
